import SimpleDropdown from '~/shared/components/SimpleDropdown';
import Typography from '~/shared/components/Typography';
import {
  ActionTypeFilterValue,
  actionTypeItems,
  countForActionType,
} from '~/shared/components/filters/actionTypeFilter';

export type { ActionTypeFilterValue } from '~/shared/components/filters/actionTypeFilter';

const itemLabels = actionTypeItems.map((item) => item.label);

export interface ActionTypeDropdownProps {
  selectedType: ActionTypeFilterValue;
  onSelect: (type: ActionTypeFilterValue) => void;
  typeCounts?: Partial<Record<ActionTypeFilterValue, number>>;
  typeCountsLoading?: boolean;
  allActionsCount?: number;
  allActionsCountLoading?: boolean;
}

export default function ActionTypeDropdown({
  selectedType,
  onSelect,
  typeCounts = {},
  typeCountsLoading = false,
  allActionsCount,
  allActionsCountLoading = false,
}: ActionTypeDropdownProps) {
  const selectedItem = actionTypeItems.find((item) => item.value === selectedType);
  const selectedLabel = selectedItem?.label ?? 'All Actions';
  const selectedCount = countForActionType({
    type: selectedType,
    typeCounts,
    allActionsCount,
  });
  const isCountLoading = selectedType ? typeCountsLoading : allActionsCountLoading;

  return (
    <SimpleDropdown
      aria-label="Action type filter"
      className="min-w-[290px]"
      menuButtonClassName="h-[36px]! 4xl:h-[44px]!"
      items={itemLabels}
      selectedItem={selectedLabel}
      displayLabel={selectedLabel}
      menuButtonLabelClassName="text-primary-900 font-semibold"
      renderItemEnd={(label) => {
        const item = actionTypeItems.find((i) => i.label === label);
        if (!item) return null;
        const count = countForActionType({
          type: item.value,
          typeCounts,
          allActionsCount,
        });
        const loading = item.value ? typeCountsLoading : allActionsCountLoading;
        if (loading || count === undefined) return null;
        return (
          <Typography variant="buttons-2" color="text-gray-600">
            {count.toLocaleString()}
          </Typography>
        );
      }}
      renderButtonEnd={() => {
        if (isCountLoading || selectedCount === undefined) return null;
        return (
          <Typography variant="buttons-2" color="text-gray-600">
            {selectedCount.toLocaleString()}
          </Typography>
        );
      }}
      onSelect={(label) => {
        const match = actionTypeItems.find((item) => item.label === label);
        if (match !== undefined) {
          onSelect(match.value);
        }
      }}
    />
  );
}
